import React from 'react';
import config from 'react-global-configuration';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Highlight } from 'react-instantsearch';
import {
  SearchResults as DefaultSearchResults,
} from '@uncinc/react-searchkit';

import {
  OF_SITE_NAME,
  KP_SITE_NAME,
} from '../../../config/constants';

import { mappedType } from '../config';

import './style.scss';

const Item = ({ hit }) => {
  const apiUrl = config.get('API_URL');
  const currentDomain = config.get('CURRENT_DOMAIN_DRUPAL_IDENTIFIER');
  const hitDomain = hit.field_domain_access?.[0];
  let url = hit.url[0];

  // Ensure we correct to the correct domain for KP content on OF
  if (hitDomain && currentDomain !== hitDomain) {
    url = `${apiUrl.replace(`www.${OF_SITE_NAME}.`, `${KP_SITE_NAME}.`)}${url}`;
  }

  const answerType = hit.type_of_answer?.[0];

  return (
    <div className="Search__result_item">
      <CoreLink href={url}>
        <div className="row">
          <div className="col-12">
            <div className="Search__result_item__type">
              <div className="Search__result_item__type__left">
                {mappedType(hit.type[0], hit.question_title?.[0])}
              </div>
              <div className="Search__result_item__type__right">
                {answerType && (
                  <div>
                    <span className={`icon icon-${answerType.toLowerCase()} icon-variant-1`} />
                    <span className="answertype">{answerType}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="Search__result_item__title">
              <h4>
                <span className="title-icon">
                  <i className="icon icon-arrow-right" />
                </span>
                <Highlight attribute="title" hit={hit} />
              </h4>
            </div>
          </div>
          <div className="col-12">
            <div className="Search__result_item__body">
              <div className="Search__result_item__body__text">
                {hit.body && (
                  <Highlight attribute="body" hit={hit} />
                )}
              </div>
              {hit.image_style_uri?.[0] && (
                <div className="Search__result_item__body__image">
                  <Image
                    src={hit.image_style_uri[0]}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {config.get('CURRENT_DOMAIN') === 'of' && ['kp_question', 'kp_answer'].includes(hit.type[0]) && (
          <div className="Logo Logo--kp" />
        )}
      </CoreLink>
    </div>
  );
};

const SearchResults = (props) => {
  const { t } = useTranslation();

  return (
    <div className="SearchResults">
      <DefaultSearchResults
        renderItem={(hit) => <Item hit={hit} />}
        emptyState={(
          <div className="SearchResults__no_results">
            <div className="alert alert-danger">
              {t('search.no_results')}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default SearchResults;
